import React from 'react'
import "../styles/global.css"
import Navbar from '../components/Navbar'
import { useAuth } from '../providers/AuthContext';
export default function Container(props) {
  const { permissions } = useAuth();
  return (
    
    <div className='flex flex-col min-h-screen'>
      {permissions?.length > 0 && (
        <><Navbar permissions={permissions}/>
        <div className='flex flex-col flex-grow'>
          {props.children}
        </div></>
      )}
      
    </div>
    
  )
}
